import { render, staticRenderFns } from "./iai._.default.vue?vue&type=template&id=e0aa5112&scoped=true&"
import script from "./iai._.default.vue?vue&type=script&lang=ts&"
export * from "./iai._.default.vue?vue&type=script&lang=ts&"
import style0 from "./iai._.default.vue?vue&type=style&index=0&id=e0aa5112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0aa5112",
  null
  
)

export default component.exports